/* eslint-disable max-len */
import PropTypes from 'prop-types'
import React, { Component } from 'react'
import { autobind } from 'core-decorators'
import { observable, action, toJS } from 'mobx'
import { observer } from 'mobx-react'
import classNames from 'classnames'

import { Link } from 'react-router'

import LoadingInfo from '../../../LoadingInfo'

import getPath from '../../../shared/utils/getPath'
import createImageUrl from '../../shared/createImageUrl'
import Icon from '../../../shared/components/Icon'

@observer
export default class FilterResults extends Component {
  /* eslint-disable react/sort-comp */
  @observable isOpen = true;
  /* eslint-enable react/sort-comp */

  static propTypes = {
    collection: PropTypes.object,
    filter: PropTypes.object,
    loading: PropTypes.bool,
    onFilterRemoved: PropTypes.func.isRequired,
    onToggleFilters: PropTypes.func.isRequired
  };

  @autobind
  @action
  handleToggleIsOpen() {
    this.isOpen = !this.isOpen
  }

  @autobind
  handleRemoveFilter({ currentTarget }) {
    this.props.onFilterRemoved({
      target: {
        value: currentTarget.value
      }
    })
  }

  @autobind
  handleMofifyFilters() {
    this.props.onToggleFilters()
  }

  renderResults() {
    const { loading, collection, filter } = this.props

    // Used to listen for changes
    // eslint-disable-next-line
    const filterString = JSON.stringify(toJS(filter));

    if (loading) {
      return <LoadingInfo>Passende Angebote werden geladen</LoadingInfo>
    }

    if (!collection.length) {
      return (
        <div className="program-list no-matches">
          Leider konnten keine passende Angebote zu den ausgew&aaum;hlten Filtern gefunden werden.
        </div>
      )
    }

    return (
      <ul className="program-list">
        {collection
          // .sort((a, b) => {
          //   return a.sanitizedOrderTitle < b.sanitizedOrderTitle
          // })
          .map((item) => {
            return (
              <li key={`${item.type}-${item.id}`}
                className={`program clearfix ${item.temporarilyNotBookable ? 'faded' : ''}`}
              >
                <Link
                  to={getPath('frontend', item.type, item.id)}
                  className="pull-left"
                >
                  <span
                    className="banner square"
                    style={{
                      backgroundImage:
                        item.images && item.images.length
                          ? `url(${createImageUrl(item.images[0])})`
                          : ''
                    }}
                  />
                </Link>
                <Link
                  to={getPath('frontend', item.type, item.id)}
                  className="title"
                >
                  {item.title}
                  {item.temporarilyNotBookable ? (<Icon className="inline" name="virus-turquoise" title={item.temporarilyNotBookableReason} />) : null}
                </Link>
                {/*}<div className="text-muted">
            {item.museum.address.location}
          </div>*/}
              </li>
            )
          })}
      </ul>
    )
  }

  render() {
    const { filter } = this.props

    return (
      <div
        id="app-filter-results"
        className={classNames('app-filter-results', { open: this.isOpen })}
      >
        <div className="result-list">
          <header>
            <h3>
              Gefundene Angebote
              <a
                onClick={this.handleToggleIsOpen}
                className="pull-right btn btn-link toggle-results"
              >
                <i className="glyphicon glyphicon-chevron-right" />
              </a>
            </h3>
          </header>
          <div className="applied-filters open">
            <div className="clearfix">
              <div className="visible-xs">
                <a className="edit-filters" onClick={this.handleMofifyFilters}>
                  Filter ändern
                </a>
              </div>
              Folgende Filter wurden gesetzt
            </div>

            <div className="filter-tag filter-school bg-school">
              <a className="content filter-open">
                {filter.school.length === 0
                  ? 'Alle Schularten'
                  : `${filter.school.length} Schulart${
                    filter.school.length === 1 ? '' : 'en'
                  }`}
              </a>
              <button
                className="filter-remove btn btn-link"
                value="school"
                onClick={this.handleRemoveFilter}
              >
                <i className="glyphicon glyphicon-trash" />
              </button>
            </div>

            <div className="filter-tag filter-subject bg-subject">
              <a className="content filter-open">
                {filter.subject.length === 0
                  ? 'Alle Fächer'
                  : `${
                    filter.subject.length === 1
                      ? '1 Fach'
                      : `${filter.subject.length} Fächer`
                  }`}
              </a>
              <button
                className="filter-remove btn btn-link"
                value="subject"
                onClick={this.handleRemoveFilter}
              >
                <i className="glyphicon glyphicon-trash" />
              </button>
            </div>

            <div className="filter-tag filter-region bg-region">
              <a className="content filter-open">
                {filter.region.length === 0
                  ? 'Alle Landkreise'
                  : `${filter.region.length} Landkreis${
                    filter.region.length === 1 ? '' : 'e'
                  }`}
              </a>
              <button
                className="filter-remove btn btn-link"
                value="region"
                onClick={this.handleRemoveFilter}
              >
                <i className="glyphicon glyphicon-trash" />
              </button>
            </div>
          </div>
          <div className="filter-results scrollable">
            {this.renderResults()}
          </div>
        </div>
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/frontend/map/components/FilterResults.js